var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCard',{staticClass:"telegram-link"},[_c('a',{staticClass:"telegram-link__link text-body-2",attrs:{"href":"https://t.me/eva_smitup","target":"_blank"}},[_vm._v("Остались вопросы? Задай их нам!")])])}
var staticRenderFns = []

export { render, staticRenderFns }